import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04633aae"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-show-border", "data-fixed", "data-sticky"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pe-main-header_status-bar" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sand-system-info-icon" }, "i", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sand-system-info-divide" }, null, -1))
const _hoisted_5 = { class: "pe-main-header_wrapper" }
const _hoisted_6 = { class: "pe-main-header_side" }
const _hoisted_7 = { class: "pe-main-header_left-custom-text" }
const _hoisted_8 = {
  key: 1,
  class: "pe-main-header_back"
}
const _hoisted_9 = {
  key: 2,
  class: "pe-main-header_back"
}
const _hoisted_10 = { class: "pe-main-header_center" }
const _hoisted_11 = { class: "pe-main-header_select-options" }
const _hoisted_12 = { class: "pe-main-header_side pe-main-header_side-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pg_icon = _resolveComponent("pg-icon")!
  const _component_CellSelect = _resolveComponent("CellSelect")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", {
    id: "peMainHeader",
    class: "pe-main-header",
    "data-show-border": _ctx.showBorder,
    "data-fixed": _ctx.fixed,
    "data-sticky": _ctx.sticky
  }, [
    _hoisted_2,
    (!_ctx.isMobile)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["sand-system-info", { 'prod-env-mark': _ctx.isProd }])
        }, [
          _hoisted_3,
          _createElementVNode("span", null, _toDisplayString(_ctx.warningInfo.env), 1),
          _createElementVNode("span", null, [
            _hoisted_4,
            _createElementVNode("span", null, _toDisplayString(_ctx.warningInfo.desc), 1)
          ])
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        (_ctx.leftContentConfig)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "pe-main-header_left-custom",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleLeftContentClick && _ctx.handleLeftContentClick(...args)))
            }, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.leftContentConfig.text), 1),
              _createVNode(_component_pg_icon, {
                name: "down-f",
                size: "24px",
                class: "pe-main-header_left-custom-icon"
              })
            ]))
          : (_ctx.leftBackConfig)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_component_pg_icon, {
                  name: "left",
                  size: "24px",
                  onClick: _ctx.handleLeftBackClick
                }, null, 8, ["onClick"])
              ]))
            : (_ctx.showBackBtn)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createVNode(_component_pg_icon, {
                    name: "left",
                    size: "24px",
                    onClick: _ctx.handleBack
                  }, null, 8, ["onClick"])
                ]))
              : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_10, [
        (_ctx.titleOptions && _ctx.titleOptions.length)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(`pe-main-header_select ${_ctx.showTitleOptions ? 'pe-main-header_select-opened' : ''}`)
            }, [
              _createElementVNode("div", {
                class: "pe-main-header_title",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleTitleOptions())),
                onKeyup: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleTitleOptions()))
              }, _toDisplayString(_ctx.titleSelected?.title), 33),
              _withDirectives(_createElementVNode("div", _hoisted_11, [
                _createVNode(_component_van_popup, {
                  show: _ctx.showTitleOptions,
                  "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showTitleOptions) = $event)),
                  class: "pe-main-header_select-options_content",
                  position: "top",
                  duration: "0.2",
                  "get-container": ".pe-main-header_select-options",
                  "close-on-popstate": "",
                  onOpen: _cache[5] || (_cache[5] = ($event: any) => (_ctx.toggleTitleOptionsWrapper(true))),
                  onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.toggleTitleOptionsWrapper(false)))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CellSelect, {
                      type: "radio",
                      modelValue: _ctx.titleSelected,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.titleSelected) = $event)),
                      optionAsValue: "",
                      options: _ctx.titleOptions,
                      onChange: _ctx.handleTitleOptionChange
                    }, null, 8, ["modelValue", "options", "onChange"])
                  ]),
                  _: 1
                }, 8, ["show"])
              ], 512), [
                [_vShow, _ctx.showTitleOptionsWrapper]
              ])
            ], 2))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "pe-main-header_title",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.testBridge && _ctx.testBridge(...args)))
            }, _toDisplayString(_ctx.title), 1))
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_12, null, 512), [
        [_vShow, _ctx.rightVisible]
      ])
    ])
  ], 8, _hoisted_1))
}